import React from 'react';
import { DateTime } from 'luxon';
import {
  Query_Persons_OptionsInput,
  useSuperAdminTableQuery
} from 'generated/graphql';

export interface IData {
  id: string;
  fullName: string;
  createdDate: DateTime;
  profileUrl: string;
  phoneNumber: string;
  email: string;
  isActive: boolean;
}

export function useQuery(options?: Query_Persons_OptionsInput) {
  const tuple = useSuperAdminTableQuery({
    variables: {
      options: {
        ...options,
        filter: {
          ...options?.filter,
          isSuperAdmin: true
        }
      }
    }
  });

  return React.useMemo(
    () => {
      const data: IData[] = tuple.data?.persons.map((node) => ({
        id: node?.id ?? '',
        fullName: node?.fullName ?? '',
        createdDate: node?.createdTimestamp ?? DateTime.now(),
        profileUrl: node?.profilePicture?.url ?? '',
        phoneNumber: node?.phoneNumber ?? '',
        email: node?.preferredEmail ?? '',
        isActive: node?.isActive
      })) ?? [];
      return {
        ...tuple,
        data
      };
    }
    , [tuple]
  );
}
